var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selectpop"},[_c('div',{staticClass:"selpop",class:{open: _vm.active}},[_c('div',{staticClass:"box"},[_c('label',[_vm._v(_vm._s(_vm.text))]),_c('span')])])])}
var staticRenderFns = []

export { render, staticRenderFns }